/**
 * Mapping Job_Status (จาก DB) → ข้อความแสดงผล (ภาษาไทย)
 */
export const JOB_STATUS_DISPLAY = {
  "ลงงาน": "มอบหมายงาน",
  "Check in ทำงาน": "กำลังทำงาน",
  "working": "กำลังทำงาน",
  "On-Site": "กำลังทำงาน",
  "ปิดงาน รอเซ็น": "ปิดงาน รอเซ็น",
  "ปิดงาน เซ็นแล้ว": "ปิดงาน เซ็นแล้ว",
  "ปิดงาน": "ปิดงาน",
  "รอส่งงาน": "รอส่งงาน",
  "ส่งงาน": "ส่งงาน",
  "ส่งงาน (Checkout)": "ส่งงาน",
  "สำเร็จ": "สำเร็จ",
  "ยกเลิก": "ยกเลิก",
  "เกิดเวลา": "เกิดเวลา",
};

export function getJobStatusDisplay(jobStatus) {
  if (!jobStatus || jobStatus === "") return "-";
  return JOB_STATUS_DISPLAY[jobStatus] || jobStatus;
}

/** แสดงสถานะแบบสั้น (สำหรับ modal รายละเอียด) - ภาษาไทย */
export const JOB_STATUS_DISPLAY_SHORT = {
  "ลงงาน": "มอบหมายงาน",
  "Check in ทำงาน": "กำลังทำงาน",
  "working": "กำลังทำงาน",
  "On-Site": "กำลังทำงาน",
  "ปิดงาน รอเซ็น": "รอเซ็น",
  "ปิดงาน เซ็นแล้ว": "เซ็นแล้ว",
  "ปิดงาน": "ปิดงาน",
  "รอส่งงาน": "รอส่งงาน",
  "ส่งงาน": "ส่งงาน",
  "ส่งงาน (Checkout)": "ส่งงาน",
  "สำเร็จ": "สำเร็จ",
  "ยกเลิก": "ยกเลิก",
  "เกิดเวลา": "เกิดเวลา",
};

export function getJobStatusDisplayShort(jobStatus) {
  if (!jobStatus || jobStatus === "") return "-";
  return JOB_STATUS_DISPLAY_SHORT[jobStatus] || jobStatus;
}
